import Api from "@/config/Api";

export default {
  getNotifications(params = {}) {
    return Api().get("/client-notifications", { params });
  },
  getNotification(id) {
    return Api().get(`/client-notifications/${id}`);
  },
  createNotification(data, config = {}) {
    return Api().post("/client-notifications", data, config);
  },
  updateNotification(id, data) {
    return Api().put(`/client-notifications/${id}`, data);
  },
  deleteNotification(id) {
    return Api().delete(`/client-notifications/${id}`);
  },
  sendNotification(id, config = {}) {
    return Api().post(`/client-notifications/${id}/send`, {}, config);
  },
  getBulkJobStatus(jobId) {
    return Api().get(`/email/bulk/${jobId}`);
  }
};
